const CIRCUMFERENCE = 295.310;
const SHOW_THRESHOLD = 100;

class BackToTop {
  constructor() {
    this.button = document.querySelector('.progress-wrap');
    this.progressPath = document.querySelector('.progress-wrap .progress-circle path');

    if (!this.button || !this.progressPath) return;

    this.progressPath.style.strokeDasharray = `${CIRCUMFERENCE} ${CIRCUMFERENCE}`;
    this.progressPath.style.strokeDashoffset = CIRCUMFERENCE;

    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.onScroll();

    this.button.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    this.button.addEventListener('mouseenter', () => {
      this.button.classList.remove('is-leaving');
      this.button.classList.add('is-entering');
    });

    this.button.addEventListener('mouseleave', () => {
      this.button.classList.remove('is-entering');
      this.button.classList.add('is-leaving');
    });
  }

  onScroll() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const progress = scrollHeight > 0 ? scrollTop / scrollHeight : 0;
    const offset = CIRCUMFERENCE * (1 - progress);

    this.progressPath.style.strokeDashoffset = offset;

    if (scrollTop > SHOW_THRESHOLD) {
      this.button.classList.add('is-visible');
    } else {
      this.button.classList.remove('is-visible');
    }
  }
}

export default BackToTop;
